import { render, staticRenderFns } from "./WeekRosterGrid.vue?vue&type=template&id=f67548fe&scoped=true"
import script from "./WeekRosterGrid.vue?vue&type=script&lang=js"
export * from "./WeekRosterGrid.vue?vue&type=script&lang=js"
import style0 from "./WeekRosterGrid.vue?vue&type=style&index=0&id=f67548fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f67548fe",
  null
  
)

export default component.exports